module.exports = __webpack_public_path__ + "img/exchangeTask.c0664a89.png";